<template>
  <div>
    <span class="text-[#FFD602] font-semibold xl:text-[20px]">Chú ý</span>
    <ul class="flex flex-col gap-2 pl-6">
      <li v-for="item of noteList" :key="item.id" class="list-disc">{{ item.content }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NoteComponent',
  data() {
    return {
      noteList: [
        {
          id: 1,
          content: 'Toàn bộ quà tặng không có giá trị quy đổi ra tiền mặt.'
        },
        {
          id: 2,
          content: 'Sau 3 tháng kể từ ngày 01/12/2025, trung tâm liên hệ khách hàng nhận quà không được, trung tâm không liên hệ được khách hàng để gửi quà tặng thì quà tặng sẽ bị huỷ.'
        },
      ]
    }
  }
}
</script>

<style>

</style>